var Balboa = require('ES/services/Balboa');
var ServicesUtils = require('ES/utils/ServicesUtils');
var reloadDisplaylists = require('../utils/reloadDisplaylists');

module.exports.init = function(){
	ServicesUtils.RadioAjax('save_UserPreferences', function(keyvals, success, failure){
		Balboa.api('/authenticate/myeventsuserpreferences/save', {
			keyvals: JSON.stringify(keyvals)
		}, function(data){
			success();
			reloadDisplaylists();
		}, function(data){
			failure((data && data.message) || 'unknown cause');
		});
	});
};



// WEBPACK FOOTER //
// ./src/services/UserPreferences.js